import { createSelectors } from '@src/stores/create-selectors';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  // whether the user has explicitly asked to see the onboarding tour
  requested: boolean;
  actions: Actions;
};

type Actions = {
  // record that the user asked for the tour, e.g. via the "Tour" nav item
  requestTour: () => void;
};

/**
 * Zustand store tracking an explicit request for the onboarding tour.
 *
 * Organizations that have opted out of the auto-launched tour do not load
 * Product Fruits at all, since a loaded script always launches the tour on its
 * own. This flag is what tells the authenticated layout to bring the script in
 * once the user asks for the tour themselves.
 */
const useOnboardingTourStoreBase = create<State>()(
  devtools(
    (set) => ({
      requested: false,
      actions: {
        requestTour: () => set({ requested: true }, false, 'requestTour'),
      },
    }),
    { name: 'useOnboardingTourState' },
  ),
);

export const useOnboardingTourStore = createSelectors(
  useOnboardingTourStoreBase,
);
